import React, { SVGProps } from 'react';

const LetterY = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.357955 0.818182H1.76989L4.59375 5.57102H4.71307L7.53693 0.818182H8.94886L5.26989 6.80398V11H4.03693V6.80398L0.357955 0.818182Z"
      fill="currentColor"
    />
  </svg>
);

export default LetterY;
